<script lang="ts">
    import SidePanel from '@amp/web-app-components/src/components/SidePanel.svelte';
    import NowPlayingInfoData from '~/components/structure/Players/components/NowPlayingInfo/NowPlayingInfoData.svelte';
    import { createEventDispatcher } from 'svelte';
    import type { QueueItemMetadata } from '~/jet/models';
    import InfoCircle from '~assets/icons/info-circle.svg';

    export let emptyInfoText: string;
    export let infoHeading: string;
    export let isOpen: boolean = false;
    export let isEmpty: boolean = true;
    export let item: QueueItemMetadata | null = null;

    const dispatch = createEventDispatcher();

    let panelId: string;
</script>

<button
    on:click={() => dispatch('toggleOpen', !isOpen)}
    type="button"
    class="now-playing-info__button"
    class:active={isOpen}
    aria-expanded={isOpen}
    aria-controls={panelId}
    data-testid="info-button"
    aria-label={infoHeading}
>
    <InfoCircle />
</button>

<SidePanel bind:show={isOpen} bind:panelId {isEmpty}>
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div slot="content" class="now-playing-info" data-testid="info-sidebar">
        <NowPlayingInfoData {item} isSidebarView={true} />
    </div>

    <div slot="empty" class="now-playing-info__empty" data-testid="info-empty">
        {emptyInfoText}
    </div>
</SidePanel>

<style lang="scss">
    @use '../../../../../styles/music-classical/core/mixins/balance-line-break'
        as *;

    .now-playing-info {
        padding-top: 10px;
        padding-bottom: 30px;
        padding-inline-start: 10px;
        padding-inline-end: 10px;
        min-height: 100%;

        :global(.credits-list__subtitle) {
            @include balance-line-break;
        }
    }

    .now-playing-info__button {
        position: relative;
        width: 32px;
        height: 28px;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: var(--z-default);

        &.active {
            &:not(:disabled) {
                background: var(--playerPlatterButtonBGFill);

                :global(svg) {
                    fill: var(--playerPlatterButtonIconFill);
                }
            }
        }

        :global(svg) {
            fill: var(--systemSecondary);
            width: 18px;
            height: 18px;
        }
    }

    .now-playing-info__empty {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding-inline-end: var(--side-panel-horizontal-padding, 0);
        padding-inline-start: var(--side-panel-horizontal-padding, 0);
    }
</style>
